export const environment = {
    production: false,
    apiUrl: 'https://voice.sdi.es',
    chatbotUrl: 'http://localhost:8080',
    testing: false
};
